import {R1C1Location, R1C1Range} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/R1C1';

export enum FormulaInputTokenType
{
    FormulaStart = 'FormulaStart',
    FormulaLazyStart = 'FormulaLazyStart',
    FormulaLiveStart = 'FormulaLiveStart',
    FunctionCall = 'FunctionCall',
    SimpleFunctionName = 'SimpleFunctionName',
    QualifiedFunctionName = 'QualifiedFunctionName',
    SheetName = 'SheetName',
    FunctionArgument = 'FunctionArgument',
    CellReference = 'CellReference',
    CellReferenceExternal = 'CellReferenceExternal',
    CellReferenceRange = 'CellReferenceRange',
    CellReferenceRangeExternal = 'CellReferenceRangeExternal',
    CellReferenceError = 'CellReferenceError',
    FormulaString = 'FormulaString',
    Decimal = 'Decimal',
    Integer = 'Integer',
    Boolean = 'Boolean',
    Operand = 'Operand',
    Space = 'Space',
    Parentheses = 'Parentheses',
    ParenthesesStart = 'ParenthesesStart',
    ParenthesesEnd = 'ParenthesesEnd',
    CalColumn = 'CalColumn',
    Array = 'Array',
    ArrayRow = 'ArrayRow',
    ArrayStart = 'ArrayStart',
    ArrayEnd = 'ArrayEnd',
    Comma = 'Comma',
    Unknown = 'Unknown',
    Redundant = 'Redundant',
    SimpleValue = 'SimpleValue'
}

export interface ITokenValueParts
{
    [key:string]:string | IFormulaToken | IFormulaToken[];
}

export interface IFormulaToken
{
    type:FormulaInputTokenType;
    value:string;
    valueParts?:ITokenValueParts;
    startIndex:number;
    endIndex:number;
}

export type FormulaToken = IFormulaToken | IFormulaToken[];

export interface ILinearFormulaToken
{
    token:IFormulaToken;
    index:number;
    functionTokenIndex:number;
    functionArgumentIndex:number;
    matchTokenIndexes:number[];
}

export interface ICellReferenceRangeFormulaToken extends IFormulaToken
{
    range:R1C1Range;
}

export interface ICellReferenceFormulaToken extends ICellReferenceRangeFormulaToken
{
    location:R1C1Location;
}

export interface ICellReferenceRangeExternalFormulaToken extends ICellReferenceRangeFormulaToken
{
    sheetName:string;
}

export interface ICellReferenceExternalFormulaToken extends ICellReferenceFormulaToken
{
    sheetName:string;
}
